/* -----------------------------------
   COLOR SWITCH CLICK
----------------------------------- */
document.addEventListener('click', function (e) {
  const link = e.target.closest('.js-similar-color,.js-fit-link');
  if (!link) return;

  e.preventDefault();

  const handle = link.dataset.handle;
  if (!handle) return;

  loadProductViaSections(handle, false);
});


/* -----------------------------------
   MAIN AJAX PRODUCT + META LOADER
----------------------------------- */
async function loadProductViaSections(handle, fromPopState = false) {
  try {
    const mainProductContainer = document.querySelector('[data-section]');
    const sectionId = mainProductContainer?.dataset.section;

    const EDITORIAL_SECTION_TYPE = 'editorial-image-with-text';
    const EDITORIAL_SECTION_ID = 'editorial_image_with_text_V3frg3';

    if (!sectionId || !mainProductContainer) {
      window.location.href = `/products/${handle}`;
      return;
    }

    /* -----------------------------
       FETCH ALL REQUIRED SECTIONS
    --------------------------------*/
    const res = await fetch(
      `/products/${handle}?sections=${sectionId},${EDITORIAL_SECTION_TYPE}`,
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    );

    const sectionsJson = await res.json();

    /* -----------------------------
       UPDATE MAIN PRODUCT SECTION
    --------------------------------*/
    if (sectionsJson[sectionId]) {
      const doc = new DOMParser().parseFromString(
        sectionsJson[sectionId],
        'text/html'
      );
      const newMainNode = doc.body.firstChild;

      if (newMainNode) {
        mainProductContainer.replaceWith(newMainNode);
      }
    } else {
      window.location.href = `/products/${handle}`;
      return;
    }
    /* -----------------------------
   UPDATE META / EDITORIAL SECTION
    --------------------------------*/
    // 1. Identify the existing section on the page
    const currentEditorial = document.querySelector(`[data-section-id="${EDITORIAL_SECTION_ID}"], .shopify-section[id*="${EDITORIAL_SECTION_TYPE}"], #AjaxImageWithText`);

    const rawHtml = sectionsJson[EDITORIAL_SECTION_TYPE];

    if (rawHtml) {
      const doc = new DOMParser().parseFromString(rawHtml, 'text/html');

      // 2. STRICTOR CHECK: Look for the specific "Row" class that contains your data
      // If this class is missing, it means the metafield is empty
      const hasData = doc.querySelector('.image-text-row') !== null;
      const newNode = doc.querySelector('.shopify-section') || doc.body.firstElementChild;

      if (hasData && newNode) {
        if (currentEditorial) {
          currentEditorial.replaceWith(newNode);
        } else {
          insertMetaSection(newNode);
        }
      } else {
        // 3. FORCE REMOVE: If the AJAX response has no 'image-text-row', 
        // the previous product's section MUST be deleted.
        if (currentEditorial) {
          currentEditorial.remove();
        }
      }
    } else {
      // 4. ABSOLUTE FALLBACK: If Shopify returns nothing at all
      if (currentEditorial) {
        currentEditorial.remove();
      }
    }
    /* -----------------------------
       PUSH HISTORY (ONLY ON CLICK)
    --------------------------------*/
    if (!fromPopState) {
      history.pushState(
        { handle },
        '',
        `/products/${handle}`
      );
    }

    /* -----------------------------
       RE-INITIALIZE SHOPIFY JS
    --------------------------------*/
    setTimeout(() => {
      document.dispatchEvent(new Event('shopify:section:load'));
      reInitAfterAjax();
    }, 50);

  } catch (err) {
    console.error('AJAX Product Load Error:', err);
    window.location.href = `/products/${handle}`;
  }
}


/* -----------------------------------
   META SECTION INSERT POSITION
----------------------------------- */
function insertMetaSection(newMeta) {
  const anchor =
    document.querySelector('#AjaxProductExtra') ||
    document.querySelector('.custom-main-product') ||
    document.querySelector('product-info');

  if (anchor) {
    anchor.appendChild(newMeta);
  }
}


/* -----------------------------------
   RE-INIT AFTER AJAX LOAD
----------------------------------- */
function reInitAfterAjax() {

  // Similar color swiper
  if (typeof initSimilarColorSwiper === 'function') {
    initSimilarColorSwiper();
  }

  // Product drawers
  if (typeof initProductDrawers === 'function') {
    initProductDrawers();
  }
  if (typeof initSizeGuide === 'function') {
    initSizeGuide();
  }
  /* ===== Custom Code Start (Re-initialize magnifier lens after AJAX load) ===== */
  if (typeof window.initMagnifierLens === 'function') {
    window.initMagnifierLens();
  }
  /* ===== Custom Code End ===== */
  // Dawn / variant safety
  document.querySelectorAll('variant-selects').forEach(el => {
    el.dispatchEvent(new Event('change', { bubbles: true }));
  });
}


/* -----------------------------------
   BACK / FORWARD BROWSER SUPPORT
----------------------------------- */
window.addEventListener('popstate', function (e) {
  if (e.state?.handle) {
    loadProductViaSections(e.state.handle, true);
  } else {
    // Fallback safety
    location.reload();
  }
});